export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8661.124a5014.jpg";